import {
  Button,
  Divider,
  Link,
  Popover,
  PopoverSurface,
  PopoverTrigger,
} from "@fluentui/react-components";
import { QuestionCircleRegular } from "@fluentui/react-icons";
import { Constants } from "common/constants";
import React from "react";
import { TERMS_AND_CONDITIONS_URL } from "../externalDiagnosticsConsent/externalDiagnosticsConsent";
import { ExternalLinkIcon } from "./externalLink";
import { useStyles } from "./header.styles";
import { Logo } from "./logo";
import { PrivacyIcon } from "./privacyIcon";
import { TermsIcon } from "./termsIcon";
import { designTokens } from "theme/customTheme";

export interface IPopoverLinkWrapper {
  link: string;
  text: string;
  icon: React.ReactNode;
  linkClassName: string;
}

export interface IHeaderProps {
  popoverLinkWrappers?: IPopoverLinkWrapper[];
  style?: React.CSSProperties;
  headerColor?: string;
  headerLogoUrl?: string;
  hideHelp?: boolean;
}

export const Header = (props: IHeaderProps) => {
  const styles = useStyles();
  const termsPath = TERMS_AND_CONDITIONS_URL;
  const dynamicBg = props.headerColor ?? designTokens.primary[900];
  return (
    <div
      style={{ backgroundColor: dynamicBg, ...props.style }}
      className={styles.headerWrapper}
    >
      <div className={styles.logoWrapper}>
        {props.headerLogoUrl ? (
          <img
            src={props.headerLogoUrl}
            alt="Client logo"
            className={styles.logoImage}
          />
        ) : (
          <Logo />
        )}
      </div>
      <div className={styles.infoWrapper}>
        {!props.hideHelp && (
          <div className={styles.hintWrapper}>
            <Popover positioning="above-start">
              <PopoverTrigger disableButtonEnhancement>
                <Button
                  appearance="transparent"
                  icon={<QuestionCircleRegular className={styles.hintIcon} />}
                  aria-label="Help and legal information"
                  className={styles.hintButton}
                />
              </PopoverTrigger>

              <PopoverSurface className={styles.popoverContentWrapper}>
                <div className={styles.popoverLinkWrapper}>
                  <PrivacyIcon />
                  <Link
                    href={Constants.PRIVACY_POLICY_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.headerLink}
                  >
                    Privacy Statement
                  </Link>
                  <ExternalLinkIcon />
                </div>

                <div className={styles.popoverLinkWrapper}>
                  <TermsIcon />
                  <Link
                    href={termsPath}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={styles.headerLink}
                  >
                    Terms of Use
                  </Link>
                  <ExternalLinkIcon />
                </div>
                <Divider />
                <div className={styles.versionWrapper}>
                  <p className={styles.versionText}>v.2.0</p>
                </div>
              </PopoverSurface>
            </Popover>
          </div>
        )}
      </div>
    </div>
  );
};
